import { useMemo } from 'react';
import { GraphOptionItemProps } from '../types'
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material'
import { KeyOfTargetListCategory } from 'features/search/targetList/util';

export const GraphOptionTimeItem = <T,>({
	option,
	options,
	configure,
  targetList,
	setOptionValue
}: GraphOptionItemProps<T>) => {
  const { timeList, first } = useMemo(
    () => {
      const timeList = Object.keys(configure.axis).filter((key) => configure.axis[key].time !== undefined)
      const first = timeList.length > 0 ? timeList[0] : undefined
      return { timeList, first }
    },
    [configure.axis]
  )
  return (
    <FormControl>
      <InputLabel id={`time-${option.id}-label`}>
        {option.label}
      </InputLabel>
      <Select
        labelId={`time-${option.id}-label`}
        label={option.label}
        id={`time-${option.id}`}
        size="small"
        value={
          options.find((opt) => opt.id === option.id)?.value ?? (
            option.nullable ? '**' : option.default ?? first ?? ''
          )
        }
        onChange={(event) =>
          setOptionValue(option.id, event.target.value)
        }
      >
        { option.nullable && (
          <MenuItem key={`time-empty`} value="**">
            なし
          </MenuItem>
        ) }
        { timeList.map((timeType) => {
          const def = configure.axis[timeType]
          return def ? (
            <MenuItem key={`time-${timeType}`} value={timeType}>
              {def.title}
            </MenuItem>
          ) : <></>
        })}
        {targetList?.category?.map((category, i) =>
          <MenuItem
            key={`rank-category-${i}-${category.sequence}`}
            value={`${KeyOfTargetListCategory}${category.sequence}`}
          >
            {category.title}
          </MenuItem>
        )}
      </Select>
    </FormControl>
  )
}
